import { VirtualCurrency } from 'api/virtual-currency/types'

export const virtualCurrencies: VirtualCurrency[] = [
  {
    id: '1',
    application: {
      id: '1',
    },
    name: 'VC 1',
    textIdentifier: 'vc_1',
    isDefault: true,
    iconUrl: '',
    createdAt: '2021-12-07T22:55:13Z',
    updatedAt: '2022-01-28T18:02:39Z',
  },
  {
    id: '2',
    application: {
      id: '2',
    },
    name: 'Bottle',
    textIdentifier: 'bottle',
    isDefault: true,
    iconUrl: '',
    createdAt: '2021-12-07T22:55:13Z',
    updatedAt: '2022-01-28T18:02:39Z',
  },
]
